module.exports = __webpack_public_path__ + "img/AT0000002582102.7798705b.png";